import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../service/auth.service';
import swal from 'sweetalert2';
import { UserService } from '../service/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DesignService } from '../service/design.service';
import { SecurityService } from '../service/security.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  loginForm: FormGroup
  submitted: boolean = false
  invalidLogin: boolean = false
  returnUrl: string = ""

  constructor(
    private formBuilder: FormBuilder, 
    private router: Router, 
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private designService: DesignService,
    private securityService: SecurityService
  ) { }

  get form() { return this.loginForm.controls; }

  get logoUrl(): string {
    return this.designService.getLogoUrl()
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      user: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }

    this.performLogin(this.form.user.value)
  }

  performLogin(userName: string) {
    this.submitted = true
    this.invalidLogin = false

    this.spinner.show();

    this.securityService.requestPasswordChange(userName)
      .subscribe(() => {
        this.spinner.hide();
        swal.fire("Sucesso", `Um e-mail foi enviado para ${this.form.user.value} com o link para alteração de senha.`, "success")
        this.goToLogin();
      },
      err => {
        this.spinner.hide();
        this.invalidLogin = true;
      });
  }

  formHasErrors() {
    return this.loginForm.invalid
  }

  userHasErrors() {
    return this.form.user.errors && this.form.user.errors.required
  }

  voltar(){
    this.goToLogin();
  }

  private goToLogin() {
    this.router.navigate(['login']);
  }
}
